import { render, staticRenderFns } from "./add-dept-role.vue?vue&type=template&id=4b2f68de&scoped=true&"
import script from "./add-dept-role.vue?vue&type=script&lang=ts&"
export * from "./add-dept-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f68de",
  null
  
)

export default component.exports